module.exports = __webpack_public_path__ + "fonts/2e9af08f-0faf-45e3-9767-78a700434af3.8c207dee.eot";